import { IVideo } from "../video/video.model";
import { ILiveStream } from "../live-stream/live-stream.model";

/** Who did something to a task; shared with the appointment notes on the API side. */
export enum EActorType {
  Admin = 1,
  Coach = 2,
  Student = 3,
  System = 4,
  Mentor = 5,
}

/**
 * A task the coach assigned to a student. The student sees it too and may tick it off, which is
 * why the record keeps who created it and who completed it.
 *
 * A task may point at one piece of content to watch — the coach assigns it from the student's own
 * library — in which case the API sends enough of that video or stream to draw a card for it.
 */
export interface ICoachTask {
  id: number;
  content: string;
  isCompleted: boolean;
  completedAt: string | null;
  createdBySource: EActorType;
  completedBySource: EActorType | null;
  createdAt: string;
  updatedAt: string;
  videoId?: number | null;
  liveStreamId?: number | null;
  video?: IVideo | null;
  liveStream?: ILiveStream | null;
}
